import { SVGProps } from 'react';

const SvgTrashSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M6.077 2.077a.833.833 0 0 1 .59-.244h2.666a.833.833 0 0 1 .834.834V3.5H5.833v-.833c0-.221.088-.433.244-.59Zm5.09.59V3.5H14a.5.5 0 0 1 0 1h-.833v8.833a1.833 1.833 0 0 1-1.834 1.834H4.667a1.833 1.833 0 0 1-1.834-1.834V4.5H2a.5.5 0 0 1 0-1h2.833v-.833A1.833 1.833 0 0 1 6.667.833h2.666a1.833 1.833 0 0 1 1.834 1.834ZM3.833 4.5v8.833a.833.833 0 0 0 .834.834h6.666a.833.833 0 0 0 .834-.834V4.5H3.833Zm3.334 2.833a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Zm2.166-.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgTrashSmall;
